import { render, staticRenderFns } from "./SfBottomNavigation.vue?vue&type=template&id=ebccbd82&"
import script from "./SfBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./SfBottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SfBottomNavigation.vue?vue&type=style&index=0&id=ebccbd82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports